module.exports = __webpack_public_path__ + "media/paws/paw-yellow-alt-ec6fabb1.svg";